// function renderOpcoesPlano() {
//   if(planos.length > 1){
//     const botoes = planos.map((planoItem: PlanoVinculadoEntidade, index: number) => {
//       const PlanoSelecionado = planoItem === plano;
//       return(
//         <Button
//           type={PlanoSelecionado ? "secondary" : "primary"}
//           disabled={PlanoSelecionado}
//           onClick={() => carregarPlano(planoItem.CD_PLANO)}
//         >
//           {planoItem.DS_PLANO}
//         </Button>
//       );
//     });
//     return(
//       <div>
//         <Row>
//           {/* <Col> */}
//             <span>{"Escolha um Plano:"}</span>
//           {/* </Col> */}
//         </Row>
//         <Row>
//           {/* <Col> */}
//             {botoes}
//           {/* </Col> */}
//         </Row>
//       </div>
//     );
//   }
//   return null;
// }

import React from "react";

import { PlanoButtonContainer, PlanoButton } from "./styles";

const ListaPlanos: React.FC<any> = ({ planos, onChange, cdPlanoAtivo }) => {
  return (
    <div>
      {planos.map((plano: any, index: number) => (
        <PlanoButtonContainer key={index}>
          <PlanoButton
            ativo={plano.CD_PLANO === cdPlanoAtivo}
            disabled={plano.CD_PLANO === cdPlanoAtivo}
            onClick={() => onChange(plano)}
          >
            <b>{plano.DS_PLANO}</b>
            <div>Situação: {plano.DS_CATEGORIA}</div>
          </PlanoButton>
        </PlanoButtonContainer>
      ))}
    </div>
  );
};

export default ListaPlanos;